import { useEffect } from 'react';
import {
  CentralBuyerListParams,
  ConsortiaResponse,
} from 'src/apis/aggregate-eu/types';
import { AggregateEuRootRequest } from 'src/apis/aggregate-eu/use-aggregate-eu-root';
import { Successful, useAxios } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';
import urlTemplate from 'url-template';

type HookConfig = {
  aggregateEuRootRequest: Successful<AggregateEuRootRequest>;
  params?: CentralBuyerListParams;
};

export function useGetConsortia({
  aggregateEuRootRequest,
  params = {},
}: HookConfig) {
  const link = aggregateEuRootRequest.response.data._links?.consortia?.href;

  const consortia = useAxios(
    (axios, signal, requestParams) => {
      if (!link) throw new Forbidden();

      const url = urlTemplate.parse(link).expand({});

      return axios.request<ConsortiaResponse>({
        signal,
        url,
        params: requestParams,
      });
    },
    {
      neededOnPageLoad: true,
      onError(error) {
        if (error instanceof Forbidden) {
          return error;
        } else {
          throw error;
        }
      },
    }
  );
  useEffect(() => {
    if (!link) return;
    consortia.execute(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [link]);

  return consortia;
}

export type GetConsortiaRequest = ReturnType<typeof useGetConsortia>;
